import React from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import DocumentLimitAlert from '~/components/shared/document_limit_alert';

const DocumentLimitAlertChecker = ({
  showLimitAlert, setShowLimitAlert, placement = 'top', children,
}) => {

  const renderPopover = (props) => (
    <Popover
      id="popover-doc-limit"
      {...props}
    >
      <Popover.Content className="bg-grey-lightest">
        <DocumentLimitAlert onClose={() => setShowLimitAlert(false)} />
      </Popover.Content>
    </Popover>
  );

  return (
    <OverlayTrigger placement={placement} overlay={renderPopover} trigger="manual" show={showLimitAlert}>
      { children }
    </OverlayTrigger>
  );
};

export default DocumentLimitAlertChecker;
